import { createAction, props } from '@ngrx/store';
import { IResponseBadRequest } from '@core/interfaces';
import { Menu } from '@core/models'

export const MENU_FIND_ALL = createAction('[Menu] Find All');
export const MENU_FIND_SUCCESS = createAction('[Menu] Find Success', props<{ menu: Menu|null }>());
export const MENU_FIND_ALL_SUCCESS = createAction('[Menu] Find All Success', props<{ menuList: Menu[] }>());

export const MENU_FAILURE = createAction('[Menu] Failure', props<{ error: IResponseBadRequest }>());

export const MENU_RESET = createAction('[Menu] Reset');
export const MENU_CLEAR_STATE = createAction('[Menu] Clear State');

export const MENU_UPDATE_LOADING = createAction('[Menu] Update Loading', props<{ loading: boolean }>());
